import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router } from '@angular/router';

import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

import { NotificationService } from '../services/notification.service';

export const roleRestrictionGuard = createAuthGuard<CanActivateFn>(async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData) => {
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  const grantedRoles = authData.grantedRoles.realmRoles;
  const routeRoles = route.data['roleRestriction'];
  
  if (routeRoles.some((role: string) => grantedRoles.includes(role))) return true;

  router.navigate(['']);
  notificationService.showToast('You don\'t have permission to access this section', { type: 'warning' });
  return false;
});
